//USER LOGIN
export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'


//SAVE ITEM
export const ADD_ITEM_REQUEST = 'ADD_ITEM_REQUEST'
export const ADD_ITEM_SUCCESS = 'ADD_ITEM_SUCCESS'
export const ADD_ITEM_FAILIRE = 'ADD_ITEM_FAILURE'

export const DELETE_ITEM_SUCCESS = 'DELETE_ITEM_SUCCESS'

//SEARCHBYNAME ITEM
export const SEARCH_ITEM_REQUEST = 'SEARCH_ITEM_REQUEST'
export const SEARCH_ITEM_SUCCESS = 'SEARCH_ITEM_SUCCESS'
export const SEARCH_ITEM_FAILIRE = 'SEARCH_ITEM_FAILIRE'


//FILTER ITEM
export const FILTER_ALL = 'FILTER_ALL'
export const FILTER_VALID = 'FILTER_VALID'
export const FILTER_NOT_VALID = 'FILTER_NOT_VALID'
export const FILTER_NO_COVER = 'FILTER_NO_COVER'
export const FILTER_NO_CATEGORY = 'FILTER_NO_CATEGORY'
export const FILTER_NO_BARCODE = 'FILTER_NO_BARCODE'
export const FILTER_NO_INTERNAL_ID = 'FILTER_NO_INTERNAL_ID'



export const CREATE_RECEVING ={
    REQUEST :'CREATE_RECEVING_REQUEST',
    SUCCESS :'CREATE_RECEVING_SUCCESS',
    FAILURE :'CREATE_RECEVING_FAILURE',
}


export const CLOSE_RECEVING ={
    REQUEST :'CLOSE_RECEVING_REQUEST',
    SUCCESS :'CLOSE_RECEVING_SUCCESS',
    FAILURE :'CLOSE_RECEVING_FAILURE',
}

export const UPDATE_RECEVING_ITEM ={
    REQUEST :'UPDATE_RECEVING_ITEM_REQUEST',
    SUCCESS :'UPDATE_RECEVING_ITEM_SUCCESS',
    FAILURE :'UPDATE_RECEVING_ITEM_FAILURE',
}

export const DELETE_RECEVING_ITEM ={
    REQUEST :'DELETE_RECEVING_ITEM_REQUEST',
    SUCCESS :'DELETE_RECEVING_ITEM_SUCCESS',
    FAILURE :'DELETE_RECEVING_ITEM_FAILURE',
}


export const CLOSE_DEFINITIVE_RECEIVING = {

    REQUEST :'CLOSE_DEFINITIVE_RECEIVING_REQUEST',
    SUCCESS :'CLOSE_DEFINITIVE_RECEIVING_SUCCESS',
    FAILURE :'CLOSE_DEFINITIVE_RECEIVING_FAILURE',
    
}


export const GET_CORRECT_ITEM = {

    REQUEST :'GET_CORRECT_ITEM_REQUEST',
    SUCCESS :'GET_CORRECT_ITEM_SUCCESS',
    FAILURE :'GET_CORRECT_ITEM_FAILURE',
    
}


export const DELETE_CORRECT_ITEM = {

    REQUEST :'DELETE_CORRECT_ITEM_REQUEST',
    SUCCESS :'DELETE_CORRECT_ITEM_SUCCESS',
    FAILURE :'DELETE_CORRECT_ITEM_FAILURE',
    
}


export const UPDATE_CORRECT_ITEM = {

    REQUEST :'UPDATE_CORRECT_ITEM_REQUEST',
    SUCCESS :'UPDATE_CORRECT_ITEM_SUCCESS',
    FAILURE :'UPDATE_CORRECT_ITEM_FAILURE',
    
}


export const DELETE_SHIPPING_ITEM = {
    REQUEST :'DELETE_SHIPPING_ITEM_REQUEST',
    SUCCESS :'DELETE_SHIPPING_ITEM_SUCCESS',
    FAILURE :'DELETE_SHIPPING_ITEM_FAILURE',
    
}

export const GET_CATEGORY = {
    REQUEST :'GET_CATEGORY_REQUEST',
    SUCCESS :'GET_CATEGORY_SUCCESS',
    FAILURE :'GET_CATEGORY_FAILURE',
}